import { RateModes } from "../../../lib/const/rateModes";
import { RateTypes } from "../../../lib/const/rateTypes";

/**
 * Тип цены/расчета в зависимости от вида цены предложения
 * @param {RateModes} rateModeId
 * @return {RateTypes | undefined}
 */

export const getRateTypeId = (rateModeId?: RateModes): RateTypes | undefined => {
  switch (rateModeId) {
    case RateModes.ONE_TIME:
      return RateTypes.FIXED_PRICE;
    case RateModes.PERIODIC:
      return RateTypes.PREPAYMENT_VOLUME;
    case RateModes.TRAFFIC:
      return undefined;
    default:
      return undefined;
  }
};
